import styled from 'styled-components/macro';
import { ellipsis } from 'polished';
import { TYPOGRAPHY, COLORS } from 'styleguide';

const Username = styled.div`
  ${ellipsis('170px')}
  margin-bottom: 4px;
  ${TYPOGRAPHY.button}
  color: ${COLORS.gray60};
`;

export default Username;
